<template>
    <div class="modal fade" id="link-authorization-modal" tabindex="-1" role="dialog" aria-labelledby="link-authorization-title" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title" id="link-authorization-title">Link Payer Authorization</div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>                        
                </div>
                <div class="modal-body p-2">
                    <div class="p-3 border-bottom" v-if="document">
                        <div>{{ document.description }}</div>
                        <div><span class="font-weight-bold">PAN:</span> {{ document.pan }}</div>
                        <div><span class="font-weight-bold">DOS:</span> {{ document.dos }}</div>                        
                    </div>
                    <div class="d-flex p-3">
                        <div class="custom-control custom-checkbox">
                            <input id="cms-document-checkbox-reason" type="checkbox" class="custom-control-input" v-model="noAuthorizationRequired" @change="onNoAuthorizationRequired($event)">
                            <label class="custom-control-label" :for="'cms-document-checkbox-reason'">
                                <span class="sr-only"></span>
                            </label>
                        </div>
                        <div>                                 
                            <div>Payer authorization is not required due to following:</div>
                            <select :class="['custom-select custom-select-sm', { 'is-invalid' : isInvalid }]" v-model="reason" :disabled="!noAuthorizationRequired">
                                <option v-for="option in reasons" :key="'no-prior-authorization-reason' + option.id" :value="option.id">{{ option.description }}</option>
                            </select>
                            <span v-if="isInvalid" class="invalid-feedback" role="alert">
                                <strong v-text="validationMsg"></strong>
                            </span>                                   
                            <textarea v-if="reason === NoPriorAuthorizationReason.OTHER" :class="['form-control mt-2', { 'is-invalid': isInvalid }]" rows="5" v-model="otherText" placeholder="Enter reason payer authorization is not required for this claim. (Required)"></textarea>
                        </div>
                    </div>                    
                    <div v-if="sections.length && selectedSection" class="d-flex align-items-stretch p-0 m-0 border-top">
                        <div class="font-weight-bold border-right sections">
                            <div v-for="section in sections" :key="'link-authorization-section-' + section" class="list-group list-group-flush" id="section-tab" role="tablist">
                                <a :class="['list-group-item list-group-item-action text-capitalize', { 'active': section === selectedSection }]" @click="selectedSection = section">{{ section }}</a>                                
                            </div>
                        </div>
                        <div class="container-fluid">                         
                            <div class="d-flex align-items-end py-2">                            
                                <div class="input-group input-group-sm flex-fill">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text"><i class="fas fa-search fa-sm text-muted"></i></div>
                                    </div>
                                    <input type="text" class="form-control" placeholder="Search Descriptions" v-model="searchString">
                                </div>
                                <div class="ml-1">
                                    <button type="button" class="btn btn-primary btn-sm" data-toggle="tooltip" title="Filter" @click="showFilters = !showFilters">
                                        <i class="fas fa-filter fa-lg"></i>
                                    </button>
                                </div>                                                                           
                            </div>
                            <fieldset v-if="showFilters" class="border rounded">
                                <legend class="w-auto legend-sm mx-2 px-2 text-muted">Filters</legend>                                                           
                                <div class="d-flex pl-3">
                                    <label class="d-inline-flex my-auto mr-2">Date Range:</label>
                                    <div class="d-inline-flex align-items-center">
                                        <input type="date" class="form-control form-control-sm" v-model="filters.dateRange.begin" @change="filters.filter = false">
                                        <span class="mx-1">To</span>
                                        <input type="date" class="form-control form-control-sm" v-model="filters.dateRange.end" @change="filters.filter = false">
                                    </div>                                                                        
                                </div>
                                <div class="d-flex justify-content-between pr-2 py-2">
                                    <button class="btn btn-link" @click="reset">Reset Filters</button>
                                    <button class="btn btn-sm btn-primary" @click="filter()">Done</button>
                                </div>
                            </fieldset>                                                               
                            <div v-if="filteredDocuments.length" class="table-container mt-2">
                                <table class="table table-sm table-font-size px-0">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th></th>
                                            <th>Description</th>
                                            <th>Uploaded/Received</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>                    
                                        <template v-if="filteredDocuments.length">
                                            <tr v-for="doc in filteredDocuments" :key="'cms-document-' + doc.id">
                                                <td class="fit">
                                                    <div class="custom-control custom-checkbox">
                                                        <input :id="'cms-document-checkbox-' + doc.id" type="checkbox" class="custom-control-input" v-model="doc.selected" @change="onChange($event)">
                                                        <label class="custom-control-label" :for="'cms-document-checkbox-' + doc.id">
                                                            <span class="sr-only"></span>
                                                        </label>
                                                    </div>
                                                </td>
                                                <td class="fit px-0">
                                                    <div class="d-flex justify-content-start align-items-center">
                                                        <div>                                                                   
                                                            <document-status-icon v-if="doc.document_status" :document-id="doc.id" :document-status="doc.document_status"></document-status-icon>
                                                            <span v-else-if="doc.document_status_count" class="fa-stack fa-xs">
                                                                <i class="fas fa-circle fa-stack-2x fa-fw text-muted"></i>
                                                                <span class="fa-stack-1x font-weight-bold text-white">{{ doc.document_status_count }}</span>
                                                            </span>                                                
                                                        </div>
                                                    </div>                                                              
                                                </td>
                                                <td :title="doc.description">{{ doc.description | truncate(50) }}</td>
                                                <td class="fit">{{ doc.created_at | localizeTime('YYYY-MM-DD HH:mm:ss') }}</td>
                                                <td class="fit">
                                                    <div class="mx-2">
                                                        <a :href="getUrl(doc)" target="_blank" title="View Document">
                                                            <i class="fas fa-file-pdf fa-lg"></i>
                                                        </a>
                                                    </div>                       
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody> 
                                </table>
                            </div>
                            <div v-else class="d-flex justify-content-center">
                                <div class="h5 text-muted mt-3">No Documents Available</div>
                            </div>                            
                        </div>                       
                    </div>                  
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary" :disabled="disableLinkButton" @click="associate()">Link</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>                        
                </div>                                           
            </div>
        </div>
    </div>      
</template>

<script>
import { NoPriorAuthorizationReason } from '../constants.js';
import DocumentStatusIcon from './documents/DocumentStatusIconComponent.vue';

export default {
    components: {
        DocumentStatusIcon
    },    
    data() {
        return {
            document: null,
            documents: [],
            searchString: '',
            showFilters: false,
            beginDate: null,
            endDate: null,
            filters: {
                filter: false,
                dateRange: {
                    begin: null,
                    end: null
                }
            },
            noAuthorizationRequired: false,
            reasons: [],
            reason: null,
            otherText: null,
            validationMsg: null,
            sections: [],
            selectedSection: null,

            NoPriorAuthorizationReason: NoPriorAuthorizationReason
        }
    },
    computed: {
        filteredDocuments: function () {
            const self = this;
            let retval = self.selectedSection ?
                self.documents[self.selectedSection].filter(e => e.description.toLowerCase().indexOf(self.searchString.toLowerCase()) !== -1) :
                [];

            // we have to convert the date to local time and drop the time portion in order to do the comparison properly
            if (self.filters.filter && self.filters.dateRange.begin && self.filters.dateRange.end) {

                retval = retval.filter(e => {
                    let createdDate = self.getLocalDate(e.created_at);
                    return (createdDate >= self.filters.dateRange.begin && createdDate <= self.filters.dateRange.end);
                });
            }
            
            return retval;
        },
        isInvalid: function () {
            return this.noAuthorizationRequired && (!this.reason || (this.reason === NoPriorAuthorizationReason.OTHER && !this.otherText));
        },
        documentId: function () {
            return this.document.historical_document_id ?? (this.document.document_id ?? this.document.id);
        },
        slug: function () {
            return this.document.historical_document_id ? '/historical' : '';
        },
        disableLinkButton: function () {

            // if no authorization required is checked then enable the link button
            if (this.noAuthorizationRequired && this.reason) { return false; }
            
            // if an authorization or dispute response is checked then enable the link button
            if (Object.values(this.documents).some((s) => s.some((e) => e.selected))) { return false; }

            return true;
        }
    },    
    methods: {
        show: function (document) {

            this.document = document;
            this.documents = [];
            this.sections = [];
            this.selectedSection = null;
            this.searchString = '';
            this.showFilters = false;
            this.filters = {
                filter: false,
                dateRange: {
                    begin: null,
                    end: null
                }
            }          
            this.noAuthorizationRequired = false;
            this.reasons = [];
            this.reason = null;
            this.otherText = null;
            this.validationMsg = null;

            axios.get(`/ajax/clients/${this.document.client_id}/claims/${this.document.claim_id}${this.slug}/documents/${this.documentId}/authorizations`)
            .then(response => {

                this.documents = response.data.documents;
                this.reasons = response.data.reasons;

                this.sections = Object.keys(this.documents);
                this.selectedSection = this.sections.length ? this.sections[0] : null;

                // set the selected section to the first section that has a selected document
                for (let section of this.sections) {
                    
                    if ((this.documents[section].filter((x) => x.selected)).length) {
                        this.selectedSection = section;
                        break;
                    }
                }

                if (response.data.no_prior_authorization_reason) {
                    this.noAuthorizationRequired = true;
                    this.reason = response.data.no_prior_authorization_reason.no_prior_authorization_reason_id;
                    this.otherText = response.data.no_prior_authorization_reason.other_text ?? null;
                }

                $('#link-authorization-modal').modal('show');
            })
            .catch(error => {
                console.log(error.response);
            });
        },
        onChange: function (e) {
            this.noAuthorizationRequired = false;
            this.reason = null;
            this.otherText = null;   
        },
        onNoAuthorizationRequired: function (e) {
            Object.keys(this.documents).forEach((section) => {
                this.documents[section].forEach((x) => x.selected = false);
            });
            this.reason = null;
            this.otherText = null;            
        },
        associate: function () {

            if (this.isInvalid) {
                this.validationMsg = 'Reason payer authorization is not required cannot be blank.';
                return;
            }

            let selectedDocuments = [];
            Object.keys(this.documents).forEach((section) => {
                selectedDocuments = selectedDocuments.concat(this.documents[section].filter(e => e.selected).map(x => x.id));
            });

            let slug = this.document.historical_document_id ? '/historical' : ''; 

            axios.post(`/ajax/clients/${this.document.client_id}/claims/${this.document.claim_id}${this.slug}/documents/${this.documentId}/authorizations`, {
                documents: selectedDocuments,
                reason: this.reason,
                otherText: this.otherText                    
            })
            .then(response => {

                $('#link-authorization-modal').modal('hide');
            })
            .catch(error => {

                console.log(error);
                $('#link-authorization-modal').modal('hide');
            });
        },
        getUrl: function (doc) {
            return this.document.historical_document_id ?
                `/clients/${doc.client_id}/claims/${doc.claim_id}/historical/documents/${doc.id}` :
                `/claims/${doc.claim_id}/documents/${doc.id}`
        },
        getLocalDate: function (value) {

            let retval = null;
            if (value) {
                let date = new Date(value);
                retval = new Date(date.getTime() - (date.getTimezoneOffset() * 60 * 1000)).toISOString().split('T')[0];
            }

            return retval;
        },
        filter: function () {
            this.filters.filter = true;
            this.showFilters = false;
        },
        reset: function () {
            this.filters = {
                filter: false,
                dateRange: {
                    begin: null,
                    end: null
                }
            }            
        }      
    },
    created() {
        eventHub.$on('show-link-authorization-modal', this.show);
    },
    beforeDestroy() {
        eventHub.$off('show-link-authorization-modal');
    },
    watch: {
        'filters.dateRange.begin': function (newValue, oldValue) {
            if (newValue != oldValue) {
                this.filters.dateRange.end = newValue;
            }
        }
    }        
}
</script>

<style scoped>
    .table-container {
        max-height: 50vh;
        overflow: auto;
    }

    .table-font-size {
        font-size: .85rem;
    }    

    .sections {
        white-space: nowrap;
        width: fit-content;
    }
    
    .legend-sm {
        font-size: 1em;
        font-weight: bold;
    }    
</style>